import {isPhone} from '@/Utils/Dimensions';
import CCColors from '../../../../Utils/CCColors';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    paddingBottom: isPhone ? 100 : 158,
    backgroundColor: CCColors.Primary.Light,
  },
  backgroundImage: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: isPhone ? 360 : 593,
    height: isPhone ? 98 : 158,
    zIndex: -1,
  },
  card: {
    backgroundColor: CCColors?.White,
    borderRadius: 12,
    padding: 16,
    marginBottom: isPhone ? 16 : 0,
  },
  cardContent: {
    flex: 1,
    padding: isPhone ? 0 : 20,
    justifyContent: 'space-between',
  },
  pawnIcon: {
    width: isPhone ? 16 : 20,
    height: isPhone ? 16 : 20,
  },
  row: {
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
  },
  subRow: {
    backgroundColor: CCColors?.Primary?.Light,
    borderRadius: 30,
    paddingHorizontal: isPhone ? 12 : 26,
    paddingVertical: isPhone ? 5 : 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  primaryButton: {
    width: '90%',
    borderRadius: 32,
  },
  iconButton: {
    width: isPhone ? 28 : 40,
    height: isPhone ? 28 : 40,
    borderRadius: isPhone ? 14 : 20,
    backgroundColor: CCColors?.Buttons?.Background,
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 100,
    height: 100,
  },
  largeImage: {
    width: isPhone ? 136 : 322,
    height: isPhone ? 112 : 336,
    borderRadius: 12,
  },
  backgroundTopImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    borderRadius: 16,
    height: isPhone ? 68 : '42%',
    zIndex: 0,
  },
  backgroundPattern: {
    position: 'absolute',
    top: isPhone ? '20%' : '25%',
    left: isPhone ? '50%' : '40%',
    width: isPhone ? 126 : 200,
    height: isPhone ? 30 : 40,
    transform: [{translateX: -60}, {translateY: -20}],
    zIndex: 0,
  },
  smallCardImage: {
    width: isPhone ? 66 : 110,
    height: isPhone ? 72 : 108,
    marginTop: isPhone ? 20 : 70,
    // marginBottom: 12,
  },
  title: {
    fontWeight: isPhone ? '700' : '500',
    marginBottom: 4,
  },
  titleSmall: {
    width: isPhone ? '100%' : '70%',
    fontWeight: isPhone ? '700' : '500',
    marginBottom: 12,
    textAlign: 'center',
  },
  subText: {
    fontWeight: '600',
    marginLeft: 4,
  },
  firstRow: {
    flexDirection: 'row',
    gap: 24,
    alignItems: 'flex-start',
  },
  secondRow: {
    flexDirection: 'row',
    gap: 24,
    marginTop: 24,
  },
  largeCard: {
    flex: 1,
    padding: 16,
    borderRadius: 12,
    backgroundColor: CCColors?.White,
    elevation: 2,
    display: 'flex',
    flexDirection: 'row',
  },
  borderColor: {
    borderWidth: 1,
    borderColor: CCColors?.Red,
  },
  smallCard: {
    height: isPhone ? 216 : '100%',
    width: '24%',
    padding: 16,
    borderRadius: 16,
    backgroundColor: CCColors?.White,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});
